module.exports = __webpack_public_path__ + "static/gary-653f36377664de7042a89b01991b9844.png";